<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      class="elevation-1"
      :right="$vuetify.rtl"
    >
      <!-- Navigation menu info -->
      <template v-slot:prepend>
        <div class="pa-4" v-if="currentSchool">
          <v-img :src="schoolLogo"></v-img>
        </div>
        <div class="title text-center" v-if="currentSchool">
          {{ currentSchool.name }}
        </div>
      </template>

      <!-- Navigation menu content -->
      <v-list dense nav>
        <template v-for="section in userMenu">
          <div :key="section.title">
            <v-subheader class="body-2 font-weight-bold">{{
              section.title
            }}</v-subheader>

            <template v-for="(item, i) in section.sub">
              <v-list-item
                :key="i"
                :to="item.link"
                v-if="checkAllow(item)"
                link
              >
                <v-list-item-icon>
                  <v-icon color="grey">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-divider></v-divider>
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dark dense flat color="primary" class="no-print" app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="title" v-if="currentSchool">{{
        currentSchool.name
      }}</v-toolbar-title>
      <v-toolbar-title class="title" v-else>ครูแคร์</v-toolbar-title>
      <v-spacer></v-spacer>
      <avatar-button v-model="menu"></avatar-button>
    </v-app-bar>

    <v-main>
      <slot></slot>
    </v-main>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";

import config from "../configs";
import Auth from "../common/firebase.auth";

import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
dayjs.extend(buddhistEra);
dayjs.locale("th");

import AvatarButton from "../components/common/AvatarButton";

export default {
  name: "App",
  computed: {
    ...mapGetters([
      "currentSchool",
      "currentUser",
      "currentRoles",
      "currentUserInfo"
    ]),
    schoolLogo() {
      if (!this.currentSchool) {
        return null;
      }
      return this.currentSchool.logoImageUrl;
    }
  },
  components: {
    AvatarButton
  },
  data: () => {
    return {
      drawer: null,
      menu: false,
      userMenu: config.navigation.menu
    };
  },
  mounted() {
    if (this.$vuetify.breakpoint.name == "xs") {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
  },
  methods: {
    menuButtonTapped() {
      this.$store.dispatch("toggleMenu", !this.showMenu);
    },

    async logout() {
      await Auth.signOut();
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },

    checkAllow(menuItem) {
      let found = this.currentRoles.find(role => {
        return menuItem.allow.includes(role);
      });

      if (!found) return false;

      return true;
    }
  }
};
</script>
